module.exports = __webpack_public_path__ + "img/1.44dbbd93.png";